import React from "react";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import ThuPhiTaoBienLaiBtn from "../tao-bien-lai";
import SendEmailModalBase from "./SendEmailModalBase";

type SendBienLaiModalProps = {
    onClose: () => void,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number,
    printDisabled?: boolean,
    buttonText?: string
}

const SendBienLaiModal: React.FC<SendBienLaiModalProps> = (props) => {
    return (
        <SendEmailModalBase
            onClose={props.onClose}
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh_id={props.ts_hocsinh_id}
            buttonText={props.buttonText}
            title="Gửi thư xác nhận đến PHHS"
            sendButtonText="Gửi thư xác nhận"
            successMessage="Đã gửi email biên lai thu phí"
            failedMessage="Không gửi được biên lai"
            loadEmailContent={bienLaiThuApi.get_email_content}
            sendEmail={bienLaiThuApi.send_bienlai}
            renderPrintButton={() => (
                !props.sf_mucphaithu.so_chung_tu.includes("RV") ? (
                    <ThuPhiTaoBienLaiBtn
                        disabled={props.printDisabled ?? false}
                        sf_mucphaithu={props.sf_mucphaithu}
                        usePopupButton={true}
                        printType="bienlai"
                        buttonText="In biên lai"
                    />
                ) : null
            )}
        />
    );
};

export default SendBienLaiModal;
